import React from "react";
import { Route } from "react-router"; // react-router v4
import queryString from "query-string";
import BakedBreadListPage from "src/container/baked_breads/BakedBreadListPage";
import BakedBreadCreatePage from "src/container/baked_breads/BakedBreadCreatePage";
import BakedBreadEditPage from "src/container/baked_breads/BakedBreadEditPage";
import BakedBreadCompletePage from "src/container/baked_breads/BakedBreadCompletePage";
// import OrderItemListPage from 'src/container/order/OrderItemListPage';
// import OrderCreateNotificationPage from 'src/container/order/OrderCreateNotificationPage';
// import OrderConfirmNotificationPage from 'src/container/order/OrderConfirmNotificationPage';
// import OrderCompleteNotificationPage from 'src/container/order/OrderCompleteNotificationPage';
import NotificationCreatePage from "src/container/notifications/NotificationCreatePage";
import NotificationMultipleConfirmPage from "src/container/notifications/NotificationMultipleConfirmPage";
import NotificationCompletePage from "src/container/notifications/NotificationCompletePage";
import NotificationTemplateIndexPage from "src/container/notification_templates/NotificationTemplateIndexPage";
import NotificationTemplateCreatePage from "src/container/notification_templates/NotificationTemplateCreatePage";
import NotificationTemplateEditPage from "src/container/notification_templates/NotificationTemplateEditPage";
import ReservationIndexPage from "src/container/reservations/ReservationIndexPage";
import ReservationCreatePage from "src/container/reservations/ReservationCreatePage";
import ReservationEditPage from "src/container/reservations/ReservationEditPage";
import ReservationCompletePage from "src/container/reservations/ReservationCompletePage";
import ReservationHistoryPage from "src/container/reservations/history/ReservationHistoryPage";
import ReservationOrderPage from "src/container/reservations/orders/ReservationOrderPage";
import ReservationOrderDetailPage from "src/container/reservations/orders/ReservationOrderDetailPage";

export const OrderRoutes = (props: any) => [
  // <Route
  //   exact
  //   path="/order"
  //   key={'OrderItemListPage'}
  //   render={() => <OrderItemListPage {...props} />}
  // />,
  <Route
    exact
    path="/notifications/create"
    key={"NotificationCreatePage"}
    render={() => (
      <NotificationCreatePage
        notification_template_id={
          queryString.parse(props.history.location.search)
            .notification_template_id as string
        }
        {...props}
      />
    )}
  />,
  <Route
    exact
    path="/notifications/multiple_confirm"
    key={"NotificationMultipleConfirmPage"}
    render={() => (
      <NotificationMultipleConfirmPage
        notification_template_ids={
          queryString.parse(props.history.location.search)
            .notification_template_ids as string
        }
        {...props}
      />
    )}
  />,
  <Route
    exact
    path="/notifications/complete"
    key={"NotificationCompletePage"}
    render={() => <NotificationCompletePage {...props} />}
  />,
  <Route
    exact
    path="/notification_templates"
    key={"NotificationTemplateIndexPage"}
    render={() => (
      <NotificationTemplateIndexPage
        notification_template_ids={
          queryString.parse(props.history.location.search)
            .notification_template_ids as string
        }
        {...props}
      />
    )}
  />,
  <Route
    exact
    path="/notification_templates/create"
    key={"NotificationTemplateCreatePage"}
    render={() => <NotificationTemplateCreatePage {...props} />}
  />,
  <Route
    exact
    path="/notification_templates/:id/edit"
    key={"NotificationTemplateEditPage"}
    render={({ match }) => (
      <NotificationTemplateEditPage id={match.params.id} {...props} />
    )}
  />,
  <Route
    exact
    path="/reservations"
    key={"ReservationIndexPage"}
    render={() => <ReservationIndexPage {...props} />}
  />,
  <Route
    exact
    path="/reservations/create"
    key={"ReservationCreatePage"}
    render={() => <ReservationCreatePage {...props} />}
  />,
  <Route
    exact
    path="/reservations/complete"
    key={"ReservationCompletePage"}
    render={() => <ReservationCompletePage {...props} />}
  />,
  <Route
    exact
    path="/reservations/:id/edit"
    key={"ReservationEditPage"}
    render={({ match }) => (
      <ReservationEditPage id={match.params.id} {...props} />
    )}
  />,
  <Route
    exact
    path="/reservations/history"
    key={"ReservationHistoryPage"}
    render={() => <ReservationHistoryPage {...props} />}
  />,
  <Route
    exact
    path="/reservations/orders"
    key={"ReservationOrderPage"}
    render={() => <ReservationOrderPage {...props} />}
  />,
  <Route
    exact
    path="/reservations/orders/:id"
    key={"ReservationOrderDetailPage"}
    render={({ match }) => (
      <ReservationOrderDetailPage
        {...props}
        date={
          queryString.parse(props.history.location.search).date as
            | string
            | undefined
        }
        id={match.params.id}
      />
    )}
  />,
  <Route
    exact
    path="/baked_breads"
    key={"BakedBreadListPage"}
    render={() => <BakedBreadListPage {...props} />}
  />,
  <Route
    exact
    path="/baked_breads/create"
    key={"BakedBreadCreatePage"}
    render={() => <BakedBreadCreatePage {...props} />}
  />,
  <Route
    exact
    path="/baked_breads/:id/edit"
    key={"BakedBreadEditPage"}
    render={({ match }) => (
      <BakedBreadEditPage id={match.params.id} {...props} />
    )}
  />,
  <Route
    exact
    path="/baked_breads/complete"
    key={"BakedBreadCompletePage"}
    render={() => <BakedBreadCompletePage {...props} />}
  />,
  // <Route
  //   exact
  //   path="/order/create"
  //   key={'OrderCreateNotificationPage'}
  //   render={() => (
  //     <OrderCreateNotificationPage
  //       id={queryString.parse(props.history.location.search).bread_id as string}
  //       isConfirm={queryString.parse(props.history.location.search).isConfirm as string | undefined}
  //       {...props}
  //     />
  //   )}
  // />,
  // <Route
  //   exact
  //   path="/order/confirm"
  //   key={'OrderConfirmNotificationPage'}
  //   render={() => (
  //     <OrderConfirmNotificationPage
  //       id={queryString.parse(props.history.location.search).bread_id as string}
  //       {...props}
  //     />
  //   )}
  // />,
  // <Route
  //   exact
  //   path="/order/complete"
  //   key={'OrderCompleteNotificationPage'}
  //   render={() => <OrderCompleteNotificationPage {...props} />}
  // />,
];
